export const formatPrice = (price: number) => {
	const [whole, decimal] = price.toFixed(2).split('.');
	return { whole, decimal };
};
